<template lang="pug">
	div
		.input-group(v-if="!UsuarioID")
			.input-group-prepend
				.input-group-text
					span.fa.fa-user
			input-query(
				inputClass="form-control form-control-sm"
				url="/core/php/api/usuarios/query.php"
				:realtime="true"
				@selected="seleccionaUsuario"
			)
		.input-group(v-else)
			.input-group-prepend
				.input-group-text
					span.fa.fa-user
			input.form-control.form-control-sm(
				:disabled="true"
				:value="UsuarioNombre"
			)
			.input-group-append(v-if="!readonly")
				button.btn.btn-sm.btn-danger(@click="quitar")
					span.fa.fa-trash
</template>

<script>
import axios from 'axios'

export default {
	props: ['value', 'readonly'],
	data () {
		return {
			UsuarioID: null,
			UsuarioNombre: null
		}
	},
	created () {
		if (this.value) {
			axios.get('core/php/api/usuarios/get.php?UsuarioID=' + this.value)
				.then(res => {
					this.UsuarioID = res.data.ID
					this.UsuarioNombre = res.data.nombre + ' ' + res.data.apellidos
				})
				.catch(e => {
					console.error(e)
				})
		}
	},
	methods: {
		seleccionaUsuario (ev) {
			this.UsuarioID = ev.datos.ID
			this.UsuarioNombre = ev.datos.nombre + ' ' + ev.datos.apellidos
			this.$emit('input', ev.datos.ID)
		},
		quitar () {
			this.$emit('input', null)
			this.UsuarioNombre = null
			this.UsuarioID = null
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/seleccion-usuario/seleccion-usuario.vue